// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactsPage_container__1nGXT"};